// extracted by mini-css-extract-plugin
export default {"root":"RequestSuggestionModal_root__PwJ6Q","modalContent":"RequestSuggestionModal_modalContent__bdGH4"};